import { connect } from 'react-redux';

import { citySelector, prefectureSelector } from 'modules/locations/duck';
import { getProJobCategoriesForSignUpSelector } from 'modules/marketing-pages/duck';
import ProContent from './ProContent';
import {currentUserSelector} from 'modules/users/duck';

const mapStateToProps = (state, props) => ({
  city: citySelector(state, props),
  currentUser: currentUserSelector(state),
  prefecture: prefectureSelector(state, props),
  proJobCategoriesForSignUp: getProJobCategoriesForSignUpSelector(state),
});

export default connect(mapStateToProps, null)(ProContent);
